import React from "react"
import ReactDOM from "react-dom"
import { UserProfile } from "../../hooks/userProfile"
import { ItineraryComponent } from "./ItineraryComponent"

export const priceFormatter = (price, hideCurrency) =>
  `${new Intl.NumberFormat("da-DK", { style: "decimal", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(price)}${
    hideCurrency ? "" : " DKK"
  }`
export const hosts = document.body && document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)
export const emailValidatingRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const scrollWithOffset = (el) => {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset
  const yOffset = -100
  window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" })
}

export default class Itinerary {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.state = {
      flightInfo: elem.dataset.flightInfo,
    }
    this.init()
    return self
  }

  handleClickTracking(tracking) {
    try {
      eval(tracking)
    } catch (error) {
      console.error("Error in handleClickTracking", error)
    }
  }

  init() {
    ReactDOM.unmountComponentAtNode(this.elem)
    ReactDOM.render(
      <UserProfile>
        {(profile) => {
          if (profile) {
            return <ItineraryComponent {...this.elem.dataset} handleClickTracking={this.handleClickTracking} profile={profile} />
          } else {
            return <ItineraryComponent {...this.elem.dataset} handleClickTracking={this.handleClickTracking} profile={null} />
          }
        }}
      </UserProfile>,
      this.elem,
    )
  }
}
